module.exports = __webpack_public_path__ + "img/icon_sm_wzlysh.cad96083.png";